import { SET_SECS, SET_SCORE, SET_OVER, UPDATE_STATS, SET_PRACTICE, SET_INIT } from './actions';
import { SET_SELECTED, SET_STACK, SET_LEVEL, REMOVE_NUMBER, PAUSE } from './actions';
import { SET_POINTS, SET_POINTS_VISIBLE } from './actions';
import * as f from '../logic';
import _ from 'lodash';
import { dbdel } from '../../HOME/utils';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_SELECTED:
      return { ...state, selected: action.numbers };
    case SET_LEVEL:
      return { ...state, level: action.level };
    case SET_STACK:
      return { ...state, stack: action.stack };
    case REMOVE_NUMBER:
      return { ...state, numberToRemove: action.num };
    case PAUSE:
      return { ...state, paused: action.on };
    case SET_SECS:
      return { ...state, secs: action.secs };
    case SET_SCORE:
      return { ...state, score: action.score };
    case SET_OVER:
      return { ...state, over: action.over };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case SET_POINTS:
      return { ...state, points: action.points };
    case SET_POINTS_VISIBLE:
      return { ...state, pointsVisible: action.pointsVisible };
    case SET_PRACTICE:
      return { ...state, practice: action.on };
    case SET_INIT:
      return { ...state, init: action.on };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    stats = { plays: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
  } else {
    let { plays, aggScore, bestScore } = stats;

    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);

    stats = { plays, aggScore, aveScore, bestScore };
  }

  return { ...state, stats };
}
